<template>
  <div>
    <main-layout>
      <MainMenu />
      <v-container>
        <div class="primary--text">Term & Conditions</div>
        <div class="text-xs-right">
          <v-btn v-if="!showManage" depressed color="primary" @click="handleAddTermConditions"
            >ADD</v-btn
          >
        </div>
        <div v-if="showManage" class="mt-3">
          <TermsAndConditionsManage
            v-if="showManage"
            v-model="selectedData"
            :type="formType"
            @success="handleFetchData"
            @close="handleCloseManage"
          ></TermsAndConditionsManage>
        </div>
        <div v-else class="mt-3">
          <template v-if="dataList && dataList.length > 0">
            <template v-for="(item, index) in dataList">
              <div
                :key="index"
                class="pa-3 mb-3"
                style="border: 1px solid #ccc; border-radius: 4px"
              >
                <v-layout wrap>
                  <v-flex xs3>
                    <template v-if="!item.default_term_condition">
                      <toggle-button
                        :key="`toggle_${index}`"
                        :value="item.publish"
                        :color="$vuetify.theme.success"
                        :sync="true"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                        style="display: inline-block"
                        @change="handleChangeStatus(item.id, item.publish)"
                      />
                    </template>
                    <v-chip
                      v-if="item.default_term_condition"
                      color="primary"
                      class="white--text"
                      small
                    >
                      ค่าเริ่มต้น
                    </v-chip>
                  </v-flex>
                  <v-flex xs7>{{ item.name }}</v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <v-btn
                      fab
                      small
                      color="warning"
                      outline
                      class="mx-1 my-0"
                      @click="handleEditTermConditions(item)"
                      ><v-icon>edit</v-icon></v-btn
                    >
                    <v-btn
                      v-if="!item.default_term_condition"
                      fab
                      small
                      color="error"
                      outline
                      class="mx-1 my-0"
                      @click="handleDeleteTermConditions(item.id)"
                      ><v-icon>delete</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </div>
            </template>
            <div class="mt-2">
              <v-pagination
                v-model="pageNumber"
                :total-visible="6"
                :length="pagelength"
                @input="handleChangePage"
              ></v-pagination>
            </div>
          </template>
          <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
            No data available
          </div>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import TermsAndConditionsManage from './TermsAndConditionsManage'
import MainMenu from './MainMenu'

export default {
  components: {
    ToggleButton,
    TermsAndConditionsManage,
    MainMenu
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showManage: false,
      formType: 'add',
      selectedData: null,
      limit: 10,
      offset: 0,
      total: 0,
      pagetmp: 1,
      pageNumber: 1
    }
  },
  mounted() {
    this.handleGetTermAndConditions()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    async handleGetTermAndConditions() {
      const vm = this
      try {
        const response = await vm.getTermAndConditions()
        if (response) {
          vm.dataList = response.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getTermAndConditions() {
      const vm = this
      let data = {
        page_id: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset
      }

      vm.$store.dispatch('loading')
      const response = await toaCrmApi.getTermAndConditions({ config: data })
      vm.$store.dispatch('loading')

      if (response) {
        return response.data
      } else {
        return null
      }
    },
    async checkPublishConsent(status) {
      const vm = this
      const tempStatus = !status
      const tempList = vm.dataList
      if (tempList) {
        const isPublish = tempList.filter((el) => {
          return el.publish === true
        })

        if (tempStatus) {
          if (isPublish && isPublish.length > 0) {
            const result = await this.$swal.fire({
              html: 'สามารถเปิดใช้งานได้เพียง 1 เวอร์ชั่นเท่านั้น <br/> คุณต้องการจะเปิดใช้งานเวอร์ชั่นนี้ใช่หรือไม่ ?',
              type: 'warning',
              confirmButtonText: this.$t('Confirm'),
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true,
              showCancelButton: true
            })
            if (result.value) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          await vm.$swal.fire({
            type: 'error',
            text: 'จะต้องมี consent ที่เปิดใช้งาน 1 เวอร์ชัน'
          })
          return false
        }
      }
    },
    handleGetCurrentStatus() {},
    async handleChangeStatus(id, status) {
      const vm = this
      try {
        const result = await vm.checkPublishConsent(status)

        if (result) {
          const data = {
            page_id: vm.selectedBot.pageid,
            id,
            publish: !status
          }

          const response = await vm.updateStatusTermConditions(data)

          if (response && response.status == 200) {
            vm.handleGetTermAndConditions()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async updateStatusTermConditions(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.updateStatusTermConditions({ config: payload })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleAddTermConditions() {
      this.showManage = true
    },
    handleEditTermConditions(item) {
      this.formType = 'edit'
      this.selectedData = item
      this.showManage = true
    },
    handleDeleteTermConditions(id) {
      this.$swal
        .fire({
          type: 'warning',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.deleteTermsAndConditions(id)
          }
        })
    },
    async deleteTermsAndConditions(id) {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid,
          id: id
        }
        const response = await toaCrmApi.deleteTermConditions({ data: data })
        if (response && response.status === 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.handleGetTermAndConditions()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    handleFetchData() {
      this.showManage = false
      this.handleGetTermAndConditions()
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetTermAndConditions()
      }
    },
    handleCloseManage() {
      this.selectedData = null
      this.showManage = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/TermsAndConditions/TermsAndConditions.vue